import { createContext } from 'react';
const IconContext = /*#__PURE__*/createContext({});
export default IconContext;